module.exports = __webpack_public_path__ + "static/media/img-04.649bfb2a.jpg";